import React, { Fragment, useState, useEffect } from "react";
import PDFViewer from "pdf-viewer-reactjs";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { isMobile } from "react-device-detect";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: isMobile ? 0 : theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: isMobile ? "1em" : "3em",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: (state) =>
      state.page !== "update"
        ? theme.palette.primary.main
        : theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    height: "4em",
  },
  title: {
    flexGrow: 1,
  },
  customViewer: {
    backgroundColor: "red",
    height: "500px",
  },
}));

function Pdfviewer(props) {
  const classes = useStyles();
  const { url } = props;
  console.log("url:", url);
 
  return (
    <Fragment>
      <PDFViewer
        document={{
          url: "https://egitimfs.kodlaoyna.com/img/" + url,
        }}
        loader={<h2 style={{ color: "#fa5b35" }}>Custom loader element</h2>}
        navbarOnTop
        //npmnavigation={CustomNavigation}
      />
    </Fragment>
  );
}

export default Pdfviewer;
